<!-- 问卷创建成功页面 -->
<template>
  <div class="put">
    <div class="put-box">
      <shareCommon></shareCommon>
    </div>
  </div>
</template>

<script>
import shareCommon from "@/components/shareCommon/index.vue";
export default {
  name: "put",
  data() {
    return {};
  },
  components: { shareCommon },
};
</script>
<style lang='scss' scoped>
.put {
  height: calc(100vh - 78px);
  position: relative;
  color: #666;
  overflow: auto;
  .put-box {
    min-width: 800px;
    width: 60%;
    min-height: calc(100% - 60px);
    position: relative;
    margin: 20px auto 40px;
    /deep/ {
      .padding1 {
        padding: 66px 0;
        background-color: #fff;
        .share-way{
          margin-bottom: 76px;
        }
      }
      .padding2 {
        margin-top: 10px;
        padding: 50px 0;
        background-color: #fff;
      }
      .page-2 {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/views/put.vue